function buildPaymentsInfoForWalletManager() {
  let currentPaymentsInfo = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let data = arguments.length > 1 ? arguments[1] : undefined;
  const paymentsInfo = {
    ...currentPaymentsInfo,
    ...data
  };
  // Wallet Manager doesn't need to track modal states
  delete paymentsInfo.myWallet;
  return paymentsInfo;
}
export { buildPaymentsInfoForWalletManager as default };
